import client from '../client'
import { Vendor } from './types'
import { SelectItemResponse } from '@src/interface/api/response.interface'

export type GetVendorProfileResponse = SelectItemResponse<{ vendor: Vendor }>

export const getVendorProfile = async (): Promise<GetVendorProfileResponse> => {
	const response = await client.get<GetVendorProfileResponse>('/vendors/profile')

	return response.data
}
